import { useNavigate } from 'react-router-dom'
import { Footer } from '../components/Footer'

export default function Services() {
  const navigate = useNavigate()

  const handleNavigation = (href: string) => {
    navigate(href)
  }

  return (
    <div className="min-h-screen bg-[#d6dbdc] dark:bg-black">
      <div className="container mx-auto px-4 py-8 font-mono">
        <h1 className="text-2xl font-bold mb-4 text-black dark:text-white">Our Services</h1>
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">AI Solutions</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            We leverage cutting-edge artificial intelligence technologies to solve complex business problems. Our AI solutions include machine learning models, natural language processing, and computer vision applications.
          </p>
        </section>
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">B2B SaaS Development</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            We specialize in creating robust, scalable B2B SaaS applications that streamline business processes and enhance productivity. Our solutions are tailored to meet the unique needs of each client.
          </p>
        </section>
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Mobile App Development</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            Our team excels in developing high-performance mobile applications for both iOS and Android platforms. We focus on creating intuitive user experiences and leveraging the latest mobile technologies.
          </p>
        </section>
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">UI/UX Design</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            We create beautiful, user-centric designs that enhance user engagement and satisfaction. Our design process is iterative and collaborative, ensuring that the final product meets both user needs and business goals.
          </p>
        </section>
        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Scalable Architecture</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            We design and implement scalable, resilient architectures that can handle growing user bases and increasing data loads. Our solutions are built to be maintainable, secure, and performant.
          </p>
        </section>
      </div>
      <Footer onNavigate={handleNavigation} />
    </div>
  )
} 